var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 0C26.88 0 0 26.88 0 60C0 93.12 26.88 120 60 120C93.12 120 120 93.12 120 60C120 26.88 93.12 0 60 0ZM66 102H54V90H66V102ZM78.42 55.5L73.02 61.02C68.7 65.4 66 69 66 78H54V75C54 68.4 56.7 62.4 61.02 58.02L68.46 50.46C70.68 48.3 72 45.3 72 42C72 35.4 66.6 30 60 30C53.4 30 48 35.4 48 42H36C36 28.74 46.74 18 60 18C73.26 18 84 28.74 84 42C84 47.28 81.84 52.08 78.42 55.5Z",
    fill: "#ff1200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpRed);
export default __webpack_public_path__ + "static/media/HelpRed.dcb36f59ad8003a00a3c701b7a147c5b.svg";
export { ForwardRef as ReactComponent };